import { Inbox } from 'lucide-react';
import { cn } from '../ui/utils';

// Logo slot: every assets/providers/<provider>.svg, keyed by provider name
// (nextrequest, purview, …). See that folder's README.
const LOGOS: Record<string, string> = Object.fromEntries(
  Object.entries(
    import.meta.glob<string>('../../assets/providers/*.svg', { eager: true, query: '?url', import: 'default' }),
  ).map(([path, url]) => [path.split('/').pop()!.replace(/\.svg$/, ''), url]),
);

/** The provider's logo, or the inbox icon when it has none. */
export function ProviderIcon({ provider, className }: { provider?: string; className?: string }) {
  const logo = provider ? LOGOS[provider.toLowerCase()] : undefined;
  if (logo) {
    return (
      <img
        src={logo}
        alt=""
        aria-hidden
        data-provider={provider.toLowerCase()}
        className={cn('h-4 w-4 shrink-0 object-contain', className)}
      />
    );
  }
  return <Inbox className={cn('h-3.5 w-3.5 shrink-0', className)} aria-hidden />;
}
